import { useRef, useState } from 'react';
import { Icon } from './Icons.jsx';

const ACCEPTED_TYPES = ['image/jpeg', 'image/png'];

// Dropzone circular para foto de perfil — mesmo padrão de drag/drop do
// Step1Upload.jsx, só que redondo e sempre com uma imagem (ou placeholder).
export default function AvatarDropzone({ value, onFileSelected, uploading }) {
  const [preview, setPreview] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const fileRef = useRef();

  const pick = (file) => {
    if (!file || !ACCEPTED_TYPES.includes(file.type)) return;
    setPreview(URL.createObjectURL(file));
    onFileSelected(file);
  };

  const src = preview || value;

  return (
    <div
      onClick={() => fileRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
      onDragLeave={() => setIsDragging(false)}
      onDrop={(e) => { e.preventDefault(); setIsDragging(false); pick(e.dataTransfer.files?.[0]); }}
      role="button"
      aria-label="Alterar foto de perfil"
      style={{
        width: 92, height: 92, borderRadius: '50%', position: 'relative', cursor: 'pointer',
        background: 'var(--marble-soft)', overflow: 'hidden',
        border: `2px dashed ${isDragging ? 'var(--brand-primary)' : 'var(--border-strong)'}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <input
        ref={fileRef}
        type="file"
        accept="image/jpeg,image/png"
        style={{ display: 'none' }}
        onChange={(e) => pick(e.target.files?.[0])}
      />
      {src ? (
        <img src={src} alt="Foto de perfil" style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
      ) : (
        <Icon.camera size={26} color="var(--text-subtle)"/>
      )}
      {uploading && (
        <div style={{
          position: 'absolute', inset: 0, background: 'var(--overlay-navy-40)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Icon.loader size={22} color="var(--white)"/>
        </div>
      )}
    </div>
  );
}
